import React from "react";

const Pricing = () => (
  <section className="section-padding" style={{ backgroundColor: "#fafaf9" }}>
    <div style={{ textAlign: "center", marginBottom: "4rem" }}>
      <h3
        className="font-serif"
        style={{ fontSize: "2.5rem", color: "#1a2b56" }}
      >
        Inscripciones 2026
      </h3>
      <div
        style={{
          width: "80px",
          height: "3px",
          backgroundColor: "#c4923e",
          margin: "1rem auto",
        }}
      ></div>
    </div>
    <div className="pricing-container">
    
      <div className="price-card featured">
        <div
          style={{
            position: "absolute",
            top: "-12px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#c4923e",
            color: "white",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "10px",
            fontWeight: "bold",
          }}
        >
          GENERAL
        </div>
        <h4 style={{ color: "#1a2b56" }}>Próximamente Inscripciones</h4>
       
        <div style={{ marginBottom: "2rem" }}>
          <span
            style={{ fontSize: "2.5rem", fontWeight: "bold", color: "#1a2b56" }}
          >
            $150  
          </span>
          <span style={{ color: "#9ca3af", marginLeft: "5px" }}>USD</span>
        </div>
         <a className="btn-primary bg-gold " target="_blank" href="https://inscripcioneventos.utpl.edu.ec/enrollment/eyJwZXJpb2RvIjogIjIwMjYwMiIsInByb2dyYW1hIjogIkNPU0VfUDAiLCJjYXJyZXJhIjogIkVOQzEiLCJtYXRlcmlhIjogIkNPU0UiLCJjdXJzbyI6ICIxMTYxIiwibm9tYnJlQ3Vyc28iOiAiRU5DIFJFRCBDT01VTklDQUNJT04gT0RVQ0FMIiwic29icmVwYXNhckN1cG9zIjogIk4ifQ">Inscribirse</a>  
      </div>
    </div>
  </section>
);

export default Pricing;
